interface AiConfigTableProps {
  children: React.ReactNode;
}

export function AiConfigTable({ children }: AiConfigTableProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <table className="min-w-full divide-y divide-gray-200">{children}</table>
    </div>
  );
}
